class NotificationService {
  constructor() {
    this.permission = 'default';
    this.registration = null;
    this.init();
  }

  async init() {
    if ('Notification' in window) {
      this.permission = Notification.permission;
      console.log('Notification permission status:', this.permission);
    }
    
    // Register service worker
    this.registerServiceWorker();
  }

  async requestPermission() {
    if ('Notification' in window) {
      if (this.permission === 'default') {
        this.permission = await Notification.requestPermission();
        console.log('Notification permission requested:', this.permission);
      }
      return this.permission === 'granted';
    }
    return false;
  }

  showNotification(title, options = {}) {
    console.log('Attempting to show notification:', title, 'Permission:', this.permission);
    
    if (this.permission !== 'granted') {
      console.log('Notification permission not granted, current permission:', this.permission);
      return;
    }

    const defaultOptions = {
      icon: '/favicon.ico',
      badge: '/favicon.ico',
      tag: 'chat-message',
      requireInteraction: false,
      ...options
    };

    try {
      console.log('Creating notification with options:', defaultOptions);
      const notification = new Notification(title, defaultOptions);
      
      notification.onclick = () => {
        window.focus();
        notification.close();
        if (options.onClick) {
          options.onClick();
        }
      };

      // Auto close after 5 seconds
      setTimeout(() => notification.close(), 5000);
      
      console.log('Notification created successfully');
      return notification;
    } catch (error) {
      console.error('Error showing notification:', error);
    }
  }

  showMessageNotification(message, senderName, conversationId) {
    console.log('showMessageNotification called:', { message, senderName, conversationId, hasFocus: document.hasFocus() });
    
    if (document.hasFocus()) {
      console.log('App has focus, not showing notification');
      return; // Don't show if app is focused
    }

    const notificationTitle = `New message from ${senderName}`;
    const notificationBody = message.length > 100 ? `${message.substring(0, 100)}...` : message;
    
    console.log('Showing message notification:', notificationTitle, notificationBody);
    
    // Try to show notification
    this.showNotification(notificationTitle, {
      body: notificationBody,
      tag: `chat-${conversationId}`,
      icon: '/favicon.ico',
      requireInteraction: false,
      onClick: () => {
        // Navigate to conversation
        window.location.hash = `#/chat/${conversationId}`;
      }
    });
    
    // Also try service worker notification as fallback
    if (this.registration) {
      console.log('Sending push notification via service worker');
      this.sendPushNotification(notificationTitle, {
        body: notificationBody,
        tag: `chat-${conversationId}`,
        data: { conversationId }
      });
    }
  }

  showReactionNotification(emoji, senderName, messagePreview) {
    this.showNotification(`${senderName} reacted ${emoji}`, {
      body: messagePreview,
      tag: 'reaction'
    });
  }

  // Register service worker for background notifications
  async registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      try {
        this.registration = await navigator.serviceWorker.register('/sw.js');
        console.log('Service Worker registered:', this.registration);
        return this.registration;
      } catch (error) {
        console.error('Service Worker registration failed:', error);
      }
    }
  }

  // Send push notification through service worker
  async sendPushNotification(title, options = {}) {
    if (!this.registration || this.permission !== 'granted') return;

    try {
      await this.registration.showNotification(title, {
        icon: '/favicon.ico',
        badge: '/favicon.ico',
        requireInteraction: false,
        ...options
      });
    } catch (error) {
      console.error('Error sending push notification:', error);
    }
  }
}

const service = new NotificationService();

export const notificationService = {
  ...service,
  
  // Add missing methods for compatibility
  async getNotifications(userId) {
    return [];
  },
  
  async getUnreadNotificationsCount(userId) {
    return 0;
  },
  
  subscribeToNotifications(userId, callback) {
    return () => {};
  },
  
  async requestPermission() {
    return service.requestPermission();
  }
};